// extracted by mini-css-extract-plugin
export default {"checkout_summary":"fA","checkout_summary_wrapper":"gA","summary_items":"hA","line_items_wrapper":"iA","separator":"jA","order_summary":"kA","line_item":"lA","order__summary_item_title":"mA","recurringdis":"nA","note":"oA","carbon_emission":"pA","unlock_savings":"qA","member_perk":"rA","info":"sA","no_items":"tA","promo":"uA","order_summary_mobile":"vA","open_summary_mobile":"wA","fixed_bottom_info":"xA","open_info":"yA","text":"zA","open_summary":"AA"};
    if(module.hot) {
      // 1713361650637
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  